// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   BLEND NAVBAR
========================= */

.navbar {
  width: 100%;
  min-height: 90px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  position: sticky;
  top: 0;
  z-index: 1000;

  padding: 0 6vw;

  background: rgba(253, 250, 246, 0.97);
  border-bottom: 1px solid #e8d8ca;

  backdrop-filter: blur(10px);
}


/* =========================
   BRAND
========================= */

.brand {
  display: flex;
  flex-direction: column;

  color: #332822;
  text-decoration: none;
}

.brand:hover {
  color: #332822;
  text-decoration: none;
}

.brand-main {
  font-family: "Cormorant Garamond", Georgia, serif;

  font-size: 1.9rem;
  font-weight: 500;

  line-height: 1;

  letter-spacing: 4px;
}

.brand-sub {
  margin-top: 6px;

  font-family: "Montserrat", Arial, sans-serif;

  font-size: 0.55rem;
  font-weight: 500;

  color: #a98269;

  letter-spacing: 4px;
  text-transform: uppercase;
}


/* =========================
   NAVIGATION MENU
========================= */

.nav-menu {
  display: flex;
  align-items: center;

  gap: 35px;
}

.nav-menu a {
  position: relative;

  color: #51433b;
  text-decoration: none;

  font-family: "Montserrat", Arial, sans-serif;

  font-size: 0.7rem;
  font-weight: 500;

  letter-spacing: 1.5px;
  text-transform: uppercase;

  transition: color 0.25s ease;
}


/* =========================
   HOVER EFFECT
========================= */

.nav-menu a:hover {
  color: #a98269;
}

.nav-menu a::after {
  content: "";

  position: absolute;

  left: 0;
  bottom: -8px;

  width: 0;
  height: 1px;

  background-color: #a98269;

  transition: width 0.25s ease;
}

.nav-menu a:hover::after {
  width: 100%;
}


/* =========================
   TABLET
========================= */

@media (max-width: 900px) {
  .navbar {
    padding: 0 30px;
  }

  .nav-menu {
    gap: 20px;
  }

  .nav-menu a {
    font-size: 0.62rem;
    letter-spacing: 1px;
  }
}


/* =========================
   MOBILE
========================= */

@media (max-width: 700px) {
  .navbar {
    min-height: auto;

    flex-direction: column;
    align-items: flex-start;

    padding: 20px 25px;

    gap: 20px;
  }

  .nav-menu {
    width: 100%;

    display: flex;
    flex-wrap: wrap;

    gap: 15px 22px;
  }

  .nav-menu a {
    font-size: 0.62rem;
  }
}


/* =========================
   SMALL PHONES
========================= */

@media (max-width: 450px) {
  .brand-main {
    font-size: 1.6rem;
  }

  .brand-sub {
    font-size: 0.5rem;
  }

  .nav-menu {
    gap: 12px 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NavBarStyles.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,WAAW;EACX,gBAAgB;;EAEhB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,gBAAgB;EAChB,MAAM;EACN,aAAa;;EAEb,cAAc;;EAEd,qCAAqC;EACrC,gCAAgC;;EAEhC,2BAA2B;AAC7B;;;AAGA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,sBAAsB;;EAEtB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;;EAEjD,iBAAiB;EACjB,gBAAgB;;EAEhB,cAAc;;EAEd,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,4CAA4C;;EAE5C,kBAAkB;EAClB,gBAAgB;;EAEhB,cAAc;;EAEd,mBAAmB;EACnB,yBAAyB;AAC3B;;;AAGA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;;EAEnB,SAAS;AACX;;AAEA;EACE,kBAAkB;;EAElB,cAAc;EACd,qBAAqB;;EAErB,4CAA4C;;EAE5C,iBAAiB;EACjB,gBAAgB;;EAEhB,qBAAqB;EACrB,yBAAyB;;EAEzB,4BAA4B;AAC9B;;;AAGA;;2BAE2B;;AAE3B;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;;EAEX,kBAAkB;;EAElB,OAAO;EACP,YAAY;;EAEZ,QAAQ;EACR,WAAW;;EAEX,yBAAyB;;EAEzB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;;AAGA;;2BAE2B;;AAE3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;;AAGA;;2BAE2B;;AAE3B;EACE;IACE,gBAAgB;;IAEhB,sBAAsB;IACtB,uBAAuB;;IAEvB,kBAAkB;;IAElB,SAAS;EACX;;EAEA;IACE,WAAW;;IAEX,aAAa;IACb,eAAe;;IAEf,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;;AAGA;;2BAE2B;;AAE3B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* =========================\n   BLEND NAVBAR\n========================= */\n\n.navbar {\n  width: 100%;\n  min-height: 90px;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n\n  padding: 0 6vw;\n\n  background: rgba(253, 250, 246, 0.97);\n  border-bottom: 1px solid #e8d8ca;\n\n  backdrop-filter: blur(10px);\n}\n\n\n/* =========================\n   BRAND\n========================= */\n\n.brand {\n  display: flex;\n  flex-direction: column;\n\n  color: #332822;\n  text-decoration: none;\n}\n\n.brand:hover {\n  color: #332822;\n  text-decoration: none;\n}\n\n.brand-main {\n  font-family: \"Cormorant Garamond\", Georgia, serif;\n\n  font-size: 1.9rem;\n  font-weight: 500;\n\n  line-height: 1;\n\n  letter-spacing: 4px;\n}\n\n.brand-sub {\n  margin-top: 6px;\n\n  font-family: \"Montserrat\", Arial, sans-serif;\n\n  font-size: 0.55rem;\n  font-weight: 500;\n\n  color: #a98269;\n\n  letter-spacing: 4px;\n  text-transform: uppercase;\n}\n\n\n/* =========================\n   NAVIGATION MENU\n========================= */\n\n.nav-menu {\n  display: flex;\n  align-items: center;\n\n  gap: 35px;\n}\n\n.nav-menu a {\n  position: relative;\n\n  color: #51433b;\n  text-decoration: none;\n\n  font-family: \"Montserrat\", Arial, sans-serif;\n\n  font-size: 0.7rem;\n  font-weight: 500;\n\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n\n  transition: color 0.25s ease;\n}\n\n\n/* =========================\n   HOVER EFFECT\n========================= */\n\n.nav-menu a:hover {\n  color: #a98269;\n}\n\n.nav-menu a::after {\n  content: \"\";\n\n  position: absolute;\n\n  left: 0;\n  bottom: -8px;\n\n  width: 0;\n  height: 1px;\n\n  background-color: #a98269;\n\n  transition: width 0.25s ease;\n}\n\n.nav-menu a:hover::after {\n  width: 100%;\n}\n\n\n/* =========================\n   TABLET\n========================= */\n\n@media (max-width: 900px) {\n  .navbar {\n    padding: 0 30px;\n  }\n\n  .nav-menu {\n    gap: 20px;\n  }\n\n  .nav-menu a {\n    font-size: 0.62rem;\n    letter-spacing: 1px;\n  }\n}\n\n\n/* =========================\n   MOBILE\n========================= */\n\n@media (max-width: 700px) {\n  .navbar {\n    min-height: auto;\n\n    flex-direction: column;\n    align-items: flex-start;\n\n    padding: 20px 25px;\n\n    gap: 20px;\n  }\n\n  .nav-menu {\n    width: 100%;\n\n    display: flex;\n    flex-wrap: wrap;\n\n    gap: 15px 22px;\n  }\n\n  .nav-menu a {\n    font-size: 0.62rem;\n  }\n}\n\n\n/* =========================\n   SMALL PHONES\n========================= */\n\n@media (max-width: 450px) {\n  .brand-main {\n    font-size: 1.6rem;\n  }\n\n  .brand-sub {\n    font-size: 0.5rem;\n  }\n\n  .nav-menu {\n    gap: 12px 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
